<template>
    <article>
        <p>
            This inspection identifies issues related to the storage volumes used by the application.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/storage.png" />
        </v-card>
        
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
